import { ObservationSummary } from '../../objects/observationSummary';
import { Endpoint, RequestMethod } from '../../public_api';
import { ApiResponse } from '../apiResponse.interface';
import { MockObservationMaker } from './mockObservationMaker';

export class GetObservations extends Endpoint<
  Array<ObservationSummary>,
  GetObservationsParams,
  ObservationSummary
> {
  protected callLive(params: GetObservationsParams): Promise<Array<ObservationSummary>> {
    const callResponsePromise = this.apiCaller.doCall(
      'observations',
      RequestMethod.GET,
      this.removeNullsFromObject(params.filterParametersObject) as Record<string, string>,
    );

    return this.buildObjectsFromResponse(ObservationSummary, callResponsePromise);
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  protected callMock(params: GetObservationsParams): Promise<Array<ObservationSummary>> {
    const srcObjects = new Array<object>();
    for (let i = 0; i < 100; i++) {
      srcObjects.push(MockObservationMaker.doSummaryReplacements(i));
    }

    return this.buildObjectsFromResponse(
      ObservationSummary,
      ApiResponse.createMockResponseObject(srcObjects),
    );
  }
}

export interface GetObservationsParams {
  filterParametersObject: Record<string, string>;
}
